<template>
  <div class="container text-center leaderboard-wrapper">
    <canvas
      id="firework-canvas"
      v-show="slideActive.type == 'leaderboard' && data.audience
        && data.audience.totalPoint && data.index == 1 && !showWaitingScreen"
    />
    <div v-if="!showWaitingScreen" class="f-h">
      <div v-if="!isAudienceFormShowing" class="f-h">
        <div v-if="!loading" class="f-h">
          <LeaderBoardHead
            :type="'team'"
            :data="data"
            :currentQuiz="currentQuiz"
            :titleHTML="leaderboardTitleHTML"
            :presentationID="presentationID"
            :isShowAudiencePacingNextSlide="isShowAudiencePacingNextSlide"
            :lastSlide="lastSlide"
            :isFinalLeaderboard="isFinalLeaderboard"
            @handleClickNextSlide="handleClickNextSlide()"
          />
          <div
            class="audio-control-slide"
            v-if="isAudioControlVisible"
          >
            <AudioControl />
          </div>
          <div v-if="!waitingLeaderboard" class="f-h fix-content-leaderboard">
            <div class="swich-individual" @click="switchShowRanking()">
              <span
                v-if="showIndividual === false && isHideIndividualLeaderboard !== true"
              >
                {{ $t('Show Individual Ranking') }}
              </span>
              <span v-if="showIndividual === true">{{ $t('Show Team Ranking') }}</span>
            </div>
            <ScoreLeaderboardContent
              type="team"
              :data="scoreLeaderBoard"
              v-if="showIndividual === false"
              @nextToWaitingScreen="handleWaitingScreen()"
            />
            <ScoreLeaderboardContent
              type="individual"
              :data="scoreLeaderBoard"
              v-if="showIndividual === true && isHideIndividualLeaderboard !== true"
              @nextToWaitingScreen="handleWaitingScreen()"
            />
          </div>
        </div>
        <div v-if="loading" class="horizontal layout center center-justified">
          <Loading />
        </div>
      </div>
      <QuizJoinGameForm v-if="isAudienceFormShowing" @joinGame="handleJoinGame" />
    </div>

    <div v-if="showWaitingScreen">
      <SlideWaiting />
    </div>
  </div>
</template>
<script>
import Config from '@/config'

import * as Sentry from '@sentry/vue'

import data from '@/assets/data/all.json'
import { mapState, mapGetters } from 'vuex'

import Constant from '@/constant'
import { EmojiIndex } from 'emoji-mart-vue-fast'
import SlideWaiting from '@/components/SlideWaiting.vue'
import Loading from '@/components/Loading.vue'
import Util from '@/util'
import EventBus from '@/eventBus'
import AudioControl from '@/components/AudioControl.vue'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'

import ScoreLeaderboardContent from '@/components/types/ScoreLeaderboardContent.vue'
import LeaderBoardHead from '@/components/types/LeaderBoardHead.vue'

// Utils
import {
  getTeamCount,
  getRankingByTeamId,
  getTeamMemberRankingWithinATeamByTeamIdAndAudienceId,
} from '@/components/utils/leaderboard'

const cutOff = 10

export default {
  components: {
    SlideWaiting,
    Loading,
    AudioControl,
    QuizJoinGameForm,
    LeaderBoardHead,
    ScoreLeaderboardContent,
  },
  data() {
    return {
      openEmoji: false,
      submiting: false,
      error: false,
      audienceName: this.$store.state.audienceName,
      data: {},
      leaderboardData: {},
      intervalFirework: null,
      showWaitingScreen: false,
      myReq: null,
      loading: true,
      waitingLeaderboard: true,
      noResult: false,
      lastSlide: false,
      emojiIndex: null,
      currentQuiz: null,
      totalQuiz: null,
      showMore: false,
      countMore: 0,
      last: {},
      scoreLeaderBoard: [],
      showIndividual: false,
      fullData: null,
      countPlayer: 0,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      audiencePacing: (state) => state.presentation.audiencePacing,
      presentationID: (state) => state.presentation.id,
      isNotWhiteLabel: (state) => {
        return state.presentation.planType !== 'white-label'
      },
      isFinalLeaderboard: (state, getters) => {
        let isFinalLeaderboard = false
        if (state.slides) {
          const slidesQuiz = state.slides.filter((item) => {
            return item.type === 'pickAnswer'
          })

          const index = state.slides.findIndex((item) => item.id === getters.activeActivity.id)
          let indexQuiz = 0
          if (slidesQuiz.length) {
            indexQuiz = state.slides.findIndex(
              (item) => item.id === slidesQuiz[slidesQuiz.length - 1].id,
            )
          }
          if (index > indexQuiz) {
            isFinalLeaderboard = true
          }
        }

        return isFinalLeaderboard
      },
      isPresentationLastSlide: (state, getters) => {
        return getters.activeActivity.id === state.presentation.lastSlide
      },
      isHideIndividualLeaderboard: (state) => {
        if (state.presentation && state.presentation.isHideIndividualLeaderboard) {
          return state.presentation.isHideIndividualLeaderboard
        }
        return false
      },
      isAudioControlVisible() {
        return (
          this.slideActive
          && this.slideActive.audioLink
          && this.slideActive.audioPlayOnAudience
          && this.slideActive.id
        )
      },
    }),
    ...mapGetters({
      slideActive: 'activeActivity',
    }),
    isShowAudiencePacingNextSlide() {
      return !this.isPresentationLastSlide && this.audiencePacing
    },
    isAudienceFormShowing() {
      return !this.$store.state.audienceName || !this.$store.state.isAudienceEmojiDisabled
    },
    getTotalTeam() {
      return getTeamCount(this.leaderboardData)
    },
    getRankingForTeam() {
      return getRankingByTeamId(this.leaderboardData, this.$store.state.audienceQuizTeam)
    },
    getRankingForAudienceWithinTeam() {
      return getTeamMemberRankingWithinATeamByTeamIdAndAudienceId(
        this.leaderboardData,
        this.$store.state.audienceQuizTeam,
        this.$store.state.audienceId,
      )
    },
    isTitleLeaderboardVisible() {
      const { title } = this.slideActive
      return title == null || (title && title.trim().length)
    },
    leaderboardTitleHTML() {
      if (this.slideActive.titleHTML || this.slideActive.title) {
        return this.slideActive.titleHTML || this.slideActive.title
      }

      return this.isFinalLeaderboard
        ? this.$t('final_leaderboard')
        : this.$t('leaderboard')
    },
  },
  destroyed() {
    if (this.myReq) {
      window.cancelAnimationFrame(this.myReq)
    }
    EventBus.$off('answer-quiz')
  },
  mounted() {
    this.emojiIndex = new EmojiIndex(data)

    if (this.$store.state.audienceName) {
      this.getResult()
    } else {
      this.loading = false
    }

    EventBus.$on('answer-quiz', (data) => {
      if (this.$store.state.audienceName && this.waitingLeaderboard) {
        this.handleDataSuccess(data)
      }
    })

    if (this.slideActive.id == this.$store.state.presentation.lastSlide) {
      this.lastSlide = true
    }

    // Firing confetti effect only available if the canvas element is mounted to the DOM
    const canvas = document.getElementById('firework-canvas')
    const colors = Constant.colorsHex.filter((item, key) => {
      return item && key < 7
    })

    this.startConfettiEffect = Util.setupConfettiEffect(canvas, { resize: true },
      {
        startVelocity: 5,
        spread: 360,
        ticks: 100,
        decay: 0.98,
        particleCount: 40,
        shapes: ['circle'],
        colors,
        zIndex: 100,
      })
  },
  methods: {
    handleWaitingScreen() {
      this.showWaitingScreen = true
    },
    switchShowRanking() {
      if (this.showIndividual === null) return
      this.showIndividual = !this.showIndividual
      this.showScoreRanking(this.showIndividual)
    },

    showScoreRanking(showIndividual) {
      this.showIndividual = null
      setTimeout(() => {
        this.showIndividual = showIndividual
        if (this.showIndividual) {
          this._createDataShowListScoreIndividual(this.fullData)
        } else {
          this._createDataShowListScore(this.fullData)
        }
      }, 200)
    },
    getColor(team) {
      return team.color || Util.getAhaColor(team.id)
    },
    _createDataShowListScoreIndividual(doc) {
      let total = 0
      if (doc.audiences.length) {
        total = doc.audiences[0].t
      }

      doc.audiences.forEach((item, key) => {
        item.color = Constant.colors[key % 30]
        item.oldPercent = (item.t / total) * 100 || 1
      })

      this.scoreLeaderBoard = doc.audiences
    },
    _createDataShowListScore(doc) {
      doc.teams.forEach((team) => {
        team.color = this.getColor(team)

        team.members = doc.audiences.filter((au) => {
          return au.g === team.id
        })
      })
      let total = 0
      if (doc.teams.length) {
        total = doc.teams[0].t
      }
      doc.teams.forEach((item) => {
        item.oldPercent = (item.t / total) * 100 || 1
      })
      this.scoreLeaderBoard = doc.teams
      this.countPlayer = doc.teams.length
    },
    async getResult() {
      this.loading = true

      try {
        let doc
        if (this.$store.state.presentation.audiencePacing) {
          const res = await this.$http.post(Config.api.createLeaderboard, {
            slideId: this.slideActive.id,
            isFinalLeaderboard: this.isFinalLeaderboard,
          })
          doc = res.body
        } else {
          const url = this.slideActive.cacheLeaderboardUrl
          if (!url) {
            this.loading = false
            this.noResult = true
            return
          }
          const res = await this.$http.get(url)
          doc = res.body
        }

        this.loading = false

        if (!doc.id) {
          doc.teams = []
        }
        if (!doc.teams.length) {
          this.noResult = true
          return
        }
        this.teams = doc.teams
        this.handleDataSuccess(doc)
        this.currentQuiz = doc.currentQuiz
        this.totalQuiz = doc.totalQuiz
        this._createDataShowListScore(doc)
        this.fullData = doc
      } catch (err) {
        this.noResult = true
        this.loading = false
        Sentry.captureException(err)
      }
    },

    handleDataSuccess(doc) {
      if (!doc.id || doc.loading) {
        this.waitingLeaderboard = true
        return
      }
      this.leaderboardData = doc
      this.waitingLeaderboard = false
      const index = doc.teams.findIndex((item) => {
        return item.id == this.$store.state.audienceQuizTeam
      })

      if (index === -1) {
        this.data.totalQuiz = Util.numberWithCommas(doc.totalQuiz)
      }

      if (index != -1) {
        const audience = doc.teams[index]
        this.data.audience = {
          audience: this.audienceId,
          audienceEmoji: this.$store.state.audienceEmoji,
          audienceName: this.$store.state.audienceName,
          index: audience.i,
          totalPoint: audience.t,
          teams: doc.audiences.filter((item) => {
            return item.g === audience.id
          }),
          correctRate: audience.cR || 0,
          correctAnswerCount: audience.cAc || 0,
        }
        this.data.index = audience.i
        this.data.audience.totalPoint = Util.numberWithCommas(this.data.audience.totalPoint)
        this.data.indexFormat = Util.numberWithCommas(audience.i)
        this.data.totalQuiz = Util.numberWithCommas(doc.totalQuiz)
      }
      this.data.lastSlide = doc.lastSlide
      this.data.audiencesCount = Util.numberWithCommas(doc.teams.length)
      if (this.data.lastSlide) {
        this.slideActive.finalLeaderboard = true
      }

      // Show more
      const teams = this.data && this.data.audience && this.data.audience.teams
      if (teams && teams.length > cutOff + 2) {
        this.countMore = teams.length - cutOff
        this.last = teams[teams.length - 1]
      }
      if (
        this.isFinalLeaderboard &&
        this.data.audience &&
        this.data.audience.totalPoint &&
        this.data.index == 1
      ) {
        const self = this
        if (!this.startConfettiEffect) {
          return
        }

        let start = null

        // eslint-disable-next-line
        function step(timestamp) {
          if (!start) start = timestamp
          const progress = timestamp - start
          if (progress > 1200) {
            start = null
            self.startConfettiEffect({
              x: Math.random(),
              y: Math.random() - 0.3,
            })
          }
          self.myReq = window.requestAnimationFrame(step)
        }
        self.myReq = window.requestAnimationFrame(step)
      }
    },
    handleJoinGame() {
      this.getResult()
    },
    onChangeAudienceName() {
      this.error = false
    },
    openPickEmoji() {
      this.openEmoji = !this.openEmoji
    },
    clickOutSideEmoji() {
      if (this.openEmoji) {
        this.openEmoji = false
      }
    },
    addEmoji(emoji) {
      this.$store.state.audienceEmoji = emoji.native
      this.openEmoji = false
    },
    showMeMore() {
      this.showMore = true
    },
    shouldShowMore(teams) {
      if (!teams) {
        return []
      }
      if (teams.length <= 12) {
        return teams
      }

      if (this.showMore) {
        return teams.slice(0, teams.length - 1)
      }
      return teams.slice(0, cutOff)
    },
    handleClickOnButtonCTA() {
      window.open(Util.generateButtonCTAURL(this.presentationID, this.slideActive, 'leaderboard_CTA'), '_blank')
      Util.trackGAButtonCTA(this.presentationID, this.slideActive)
    },
    handleClickNextSlide() {
      EventBus.$emit('skipSlide')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.custom-mb-4 {
  margin-bottom: 8px;
}

.bold.list-team-member {
  line-height: 30px;
  margin: 16px 0;
  font-size: 22px;
  span {
    margin-right: 10px;
    &:not(:last-child):after {
      content: ",";
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.show-more {
  text-decoration: underline;
  cursor: pointer;
  z-index: 9999;
  position: relative;
}
.swich-individual {
  cursor: pointer;
  text-decoration: underline;
  margin-bottom: 8px;
}
.count-player {
  margin-left: 3px;
  margin-bottom: 16px;
}
.cta-wrapper {
  width: 100%;
  max-width: 400px;
  margin: 16px auto;
}
</style>
